import { useBranch } from "@/hooks/useBranch"
import { useMemo } from "react"
import { GLOBAL_STATE } from "@/constants"

function filterByState(item, state) {
	return item.state.handle.toLowerCase() === state.toLowerCase()
}

export default function useFilterData(data, useGlobalContext = false, returnFistItem = true) {
	const { selectedOption } = useBranch()

	const filteredData = useMemo(() => {
		const stateToFilterBy = useGlobalContext ? GLOBAL_STATE : selectedOption?.toLowerCase()

		if (!data.length) return null

		return data.filter((item) => filterByState(item, stateToFilterBy))
	}, [data, selectedOption, useGlobalContext])

	if (!filteredData) return null

	if (returnFistItem) {
		return filteredData.length > 0 ? filteredData[0] : null
	}

	return filteredData
}
